import { useEffect, useState } from 'react';

export const useAuth = () => {
  const [backendAuth, setBackendAuth] = useState({
    isAuthenticated: false,
    user: null,
    loading: true,
  });

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch('/auth/status', {
          credentials: 'include',
        });
        if (response.ok) {
          const authData = await response.json();
          setBackendAuth({
            isAuthenticated: authData.isAuthenticated,
            user: authData.user,
            loading: false,
          });
        } else {
          setBackendAuth({ isAuthenticated: false, user: null, loading: false });
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
        setBackendAuth({ isAuthenticated: false, user: null, loading: false });
      }
    };

    checkAuthStatus();
  }, []);

  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleLogout = () => {
    window.location.href = '/logout';
  };

  return {
    isLoading: backendAuth.loading,
    isAuthenticated: backendAuth.isAuthenticated,
    user: backendAuth.user,
    handleLogin,
    handleLogout,
  };
};
